import React from 'react';

interface CopyIconProps {
  className?: string;
  size?: number;
}

export const CopyIcon: React.FC<CopyIconProps> = ({ className = '', size = 16 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 20 20" 
      fill="currentColor" 
      className={className}
    >
    
  <path d="M15.8269 15.1667H7.33979C6.97438 15.1667 6.65972 15.0347 6.39583 14.7708C6.13194 14.5069 6 14.1923 6 13.8269V2.33979C6 1.97437 6.13194 1.65972 6.39583 1.39583C6.65972 1.13194 6.97438 1 7.33979 1H13.2308C13.4069 1 13.5765 1.03208 13.7396 1.09625C13.9025 1.16028 14.0524 1.26069 14.1892 1.3975L16.7692 3.9775C16.906 4.11431 17.0064 4.26417 17.0704 4.42708C17.1346 4.59014 17.1667 4.75972 17.1667 4.93583V13.8269C17.1667 14.1923 17.0347 14.5069 16.7708 14.7708C16.5069 15.0347 16.1923 15.1667 15.8269 15.1667ZM16.0833 5.16667H13.8846C13.6363 5.16667 13.4267 5.08132 13.256 4.91063C13.0853 4.73993 13 4.53042 13 4.28208V2.08333H7.33979C7.27563 2.08333 7.21688 2.11007 7.16354 2.16354C7.11007 2.21687 7.08333 2.27562 7.08333 2.33979V13.8269C7.08333 13.891 7.11007 13.9498 7.16354 14.0031C7.21688 14.0566 7.27563 14.0833 7.33979 14.0833H15.8269C15.891 14.0833 15.9498 14.0566 16.0031 14.0031C16.0566 13.9498 16.0833 13.891 16.0833 13.8269V5.16667ZM4.33979 18.1667C3.97437 18.1667 3.65972 18.0347 3.39583 17.7708C3.13194 17.5069 3 17.1923 3 16.8269V6.54167C3 6.38792 3.05146 6.25924 3.15438 6.15562C3.25715 6.05187 3.38479 6 3.53729 6C3.68979 6 3.81889 6.05187 3.92458 6.15562C4.03042 6.25924 4.08333 6.38792 4.08333 6.54167V16.8269C4.08333 16.891 4.11007 16.9498 4.16354 17.0031C4.21688 17.0566 4.27562 17.0833 4.33979 17.0833H12.625C12.7788 17.0833 12.9074 17.1347 13.011 17.2375C13.1148 17.3404 13.1667 17.4681 13.1667 17.6206C13.1667 17.7731 13.1148 17.9022 13.011 18.0079C12.9074 18.1138 12.7788 18.1667 12.625 18.1667H4.33979Z" fill="#2D2D2D"/>
    </svg>
  );
};



